import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { adminApi } from "../../api/admin/admin";

const initialState = {
    isAdmin: false,
};

export const checkIsAdmin = createAsyncThunk(
    'admin/checkIsAdmin',
    async (_, {rejectWithValue}) => {
        const response = await adminApi.isAdmin();
        if(response.ok) {
            return response.admin;
        }
        rejectWithValue(response.err ?? "something_went_wrong")
    }
)
const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setAdmin: (state, action) => {
            state.isAdmin = action.payload;
        }
    },
    extraReducers(builder) {
        builder.addCase(checkIsAdmin.fulfilled, (state, action) => {
            state.isAdmin = action.payload;
        })
        builder.addCase(checkIsAdmin.rejected, (state, action) => {
            state.isAdmin = false;
        })
        builder.addCase(checkIsAdmin.pending, (state, action) => {
            state.isAdmin = 'loading';
        })
    }
});

export const selectIsAdmin = (state) => state.admin.isAdmin;

export const { setAdmin } = adminSlice.actions;

export default adminSlice.reducer;